import {
    createActionFactory,
    createDataActionFactory,
    HubPersona,
    Feature,
    createActionFactoryForFeature,
} from '../../shared';

import type { UnifiedGroupAccessType } from '../../service';

export interface LeaveGroupActionPayload {
    groupId: string;
    groupName: string;
    isExpiring: boolean;
    membershipRequestsCount: number;
    userEmailAddress: string;
    isOwner: boolean;
    nextListItemId: string;
    groupSmtp: string;
    hubPersonaId: string;
}

const lpcActionFactory = createActionFactoryForFeature(Feature.LivePersonaCard);

export const livePersonaCardInitializeCompletedAction = createDataActionFactory<
    { version?: string },
    void
>('LivePersonaCardInitializeCompletedAction', Feature.LivePersonaCard, action => ({
    version: action.payload.version,
}));

export const livePersonaEditorInitializeCompletedAction = createDataActionFactory<
    { version?: string },
    void
>('LivePersonaEditorInitializeCompletedAction', Feature.LivePersonaEditor, action => ({
    version: action.payload.version,
}));

export const lpcPersonaUpdatedAction = lpcActionFactory<{ persona: HubPersona }>(
    'PersonaUpdatedAction'
);
export const lpcPersonaCreatedAction = lpcActionFactory<{ persona: HubPersona; folderId: string }>(
    'PersonaCreatedAction'
);

export const lpcGroupMembershipRequestApprovedAction = createActionFactory<{
    hubPersonaId: string;
    membershipRequestsCount: number;
    failedMembershipRequestsCount: number;
}>('GroupMembershipRequestApprovedAction', Feature.LivePersonaCard);

export const lpcAddGroupMembersClickedAction = lpcActionFactory<{}>('AddGroupMembersClickedAction');

export const lpcEditGroupClickedAction = lpcActionFactory<{}>('lpcEditGroupClickedAction');

export const lpcFollowGroupCompletedAction = lpcActionFactory<{
    groupId: string;
    hubPersonaId: string;
    isFollowed: boolean;
}>('FollowGroupCompletedAction');

export const lpcUnFollowGroupCompletedAction = lpcActionFactory<{
    groupId: string;
    hubPersonaId: string;
    isFollowed: boolean;
}>('UnFollowGroupCompletedAction');

export const lpcLeaveGroupCompletedAction = lpcActionFactory<LeaveGroupActionPayload>(
    'LpcLeaveGroupCompletedAction'
);

export const lpcJoinGroupCompletedAction = lpcActionFactory<{
    groupId: string;
    groupName: string;
    userEmailAddress: string;
    accessType: UnifiedGroupAccessType;
    hubPersonaId: string;
}>('LpcJoinGroupCompletedAction');

export const lpcPromoteGroupMemberCompletedAction = lpcActionFactory<{
    groupId: string;
    promotedMembers: number;
    hubPersonaId: string;
}>('lpcPromoteGroupMemberCompletedAction');
export const lpcRemoveGroupMemberCompletedAction = lpcActionFactory<{
    groupId: string;
    removedMembers: number;
    hubPersonaId: string;
}>('lpcRemoveGroupMemberCompletedAction');

export const lpcDemoteGroupMemberCompletedAction = lpcActionFactory<{
    groupId: string;
    demotedMembers: number;
    hubPersonaId: string;
}>('lpcDemoteGroupMemberCompletedAction');

export const lpcDemoteSelfCompletedAction = lpcActionFactory<{
    groupId: string;
    nextListItemId: string;
    hubPersonaId: string;
}>('lpcDemoteSelfCompletedAction');

export const lpcExpandedViewNavigationAction = createDataActionFactory<
    {
        persona: HubPersona;
        isNavigateBackAvailable: boolean;
    },
    { error: Error }
>('ExpandedViewNavigationAction', Feature.LivePersonaCard);

export const lpcRenewGroupCompletedAction = createActionFactory<{
    groupId: string;
    groupSmtp: string;
}>('RenewGroupCompletedAction', Feature.LivePersonaCard);
export type { DataActionFactory } from '../../shared';
export type { Action } from '../../shared';

export const lpcUpdateTransferOwnershipAction = lpcActionFactory<{
    unifiedGroupId: string;
    isTransferOwnershipDialog: boolean;
}>('lpcUpdateTransferOwnershipAction');
